import { createContext, useCallback, useContext, useState } from "react";
import QuoteModal from "@/components/site/QuoteModal";

const QuoteCtx = createContext({ openQuote: () => {} });

export function QuoteProvider({ children }) {
  const [open, setOpen] = useState(false);
  const openQuote = useCallback(() => setOpen(true), []);
  const closeQuote = useCallback(() => setOpen(false), []);
  return (
    <QuoteCtx.Provider value={{ openQuote, closeQuote }}>
      {children}
      <QuoteModal open={open} onClose={closeQuote} />
    </QuoteCtx.Provider>
  );
}

export function useQuote() {
  return useContext(QuoteCtx);
}
